<template>
  <div ref="Assessor-Report" id="Assessor-Report"> 
    <div>
        <div class="row my-3 pb-5">
            <div class="col-9 m-auto" style="min-width: 900px;">
                <div class="row">
                    <div class="col">
                        <h4><strong>Assessor Report</strong></h4>
                    </div>
                </div>
                <div class="row mt-3 page-break">
                    <div class="col w-100 page-break">
                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Programme</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.programme}}</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Unit Standards</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.unitStandards}}</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Learner Name</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.learnerName}}</strong></span>
                                </td>
                            </tr>
                        </table>
                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>ID Number</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.learnerIdNumber}}</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Attached</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                        </table>
                        <table class="w-100 page-break " style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Learner’s Personal Information Document</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Completed</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>CV and Certificates (prior achievements)</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Attached</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessment Preparation Document</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Completed</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessment Plan Document</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Completed</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Declaration of Authenticity Document</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Completed</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px">
                                        <strong>
                                            Learner’s Review of the Assessment Process
                                            Document
                                        </strong>
                                    </span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Completed</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                        </table>
                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor Name</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.assessorName}}</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor Number</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.assessorNumber}}</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessment Date</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.assessmentDate}}</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator Name</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator Number</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderation Date</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                        </table>
                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessment Appeal</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Date appealed</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Outcome of appeal</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Final Judgement</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Competent</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px" v-if="assessorReportData.competent">
                                        <strong>X</strong>
                                    </span>
                                    <span style="font-size: 18px" v-if="!assessorReportData.competent">
                                        <strong></strong>
                                    </span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Not Yet Competent</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px">
                                      <span style="font-size: 18px" v-if="assessorReportData.competent">
                                        <strong></strong>
                                      </span>
                                      <span style="font-size: 18px" v-if="!assessorReportData.competent">
                                        <strong>X</strong>
                                      </span>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-3 mt-5 pt-5 page-break">
            <div class="col-9 m-auto page-break" style="min-width: 900px;">
                <div class="row">
                    <div class="col">
                        <h4><strong>Assessor Report</strong></h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col w-100 page-break">
                        <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Did the learner provide the required evidence:</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Reference:</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Comments / Feedback</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>C</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>NYC</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break" v-if="assessorReportData.tasks.filter(x=>x.taskClassificationTypeId == 1).length">
                                <td class="blue-col" colspan="5">
                                    <table style="height:100%; padding:0px !important">
                                        <tr class="blue-col">
                                            <td style="background-color: white !important; border-right-style: solid; border-right-width: 1px; ">
                                                <img class="Feedback-icon" src="https://lateralscaffolding.blob.core.windows.net/resources/logbook-picture.png" />
                                            </td>
                                            <td class="blue-col " colspan="4">
                                                <div style="width:100%;padding-left:5px; font-size: 18px; align-self:center"><strong>Formatives</strong></div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            
                            <tr style="border-style: solid;border-width: 1px;" class="page-break" :key="questionIndex"  v-for="(question , questionIndex) in assessorReportData.tasks.filter(x=>x.taskClassificationTypeId == 1)">
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.name}}</strong></span>
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>Essential Embedded Knowledge:</strong></span>
                                    <br />
                                      <span style="font-size: 18px" v-if="question.courseEssentialEmbeddedKnowledge">{{question.courseEssentialEmbeddedKnowledge}}</span>
                                      <span style="font-size: 18px" v-else>N/A</span>
                                    <br />

                                    <span style="font-size: 18px"><strong>Unit Standard:</strong></span>
                                    <br />
                                      <span style="font-size: 18px" v-if="question.courseUnitStandard">{{question.courseUnitStandard}}</span>
                                      <span style="font-size: 18px" v-else>N/A</span>
                                    <br />

                                    <span style="font-size: 18px"><strong>Assessment Criteria:</strong></span>
                                    <br />
                                      <span style="font-size: 18px" v-if="question.courseAssessmentCriteria">{{question.courseAssessmentCriteria}}</span>
                                      <span style="font-size: 18px" v-else>N/A</span>
                                    <br />

                                    <span style="font-size: 18px"><strong>Specific Outcome:</strong></span>
                                    <br />
                                      <span style="font-size: 18px" v-if="question.courseSpecificOutcome">{{question.courseSpecificOutcome}}</span>
                                      <span style="font-size: 18px" v-else>N/A</span>
                                    <br />
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.competentMessage}}</strong></span>
                                </td>
                               
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.competent ? "X" :""}}</strong></span>
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px">{{!question.competent ? "X" :""}}</span>
                                </td>
                            </tr>
                            
                            <tr style="border-style: solid;border-width: 1px;" class="page-break" v-if="assessorReportData.tasks.filter(x=>x.taskClassificationTypeId == 2).length">
                                <td class="blue-col" colspan="5">
                                    <table style="height:100%; padding:0px !important">
                                        <tr class="blue-col">
                                            <td style="background-color: white !important; border-right-style: solid; border-right-width: 1px; ">
                                                <img class="Feedback-icon" src="https://lateralscaffolding.blob.core.windows.net/resources/logbook-picture.png" />
                                            </td>
                                            <td class="blue-col " colspan="4">
                                                <div style="width:100%;padding-left:5px; font-size: 18px; align-self:center"><strong>Summatives</strong></div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>

                            <tr style="border-style: solid;border-width: 1px;" class="page-break" :key="questionIndex"  v-for="(question , questionIndex) in assessorReportData.tasks.filter(x=>x.taskClassificationTypeId == 2)">
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.name}}</strong></span>
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>Essential Embedded Knowledge:</strong></span>
                                <br />
                                    <span style="font-size: 18px" v-if="question.courseEssentialEmbeddedKnowledge">{{question.courseEssentialEmbeddedKnowledge}}</span>
                                    <span style="font-size: 18px" v-else>N/A</span>
                                <br />

                                <span style="font-size: 18px"><strong>Unit Standard:</strong></span>
                                <br />
                                    <span style="font-size: 18px" v-if="question.courseUnitStandard">{{question.courseUnitStandard}}</span>
                                    <span style="font-size: 18px" v-else>N/A</span>
                                <br />

                                <span style="font-size: 18px"><strong>Assessment Criteria:</strong></span>
                                <br />
                                    <span style="font-size: 18px" v-if="question.courseAssessmentCriteria">{{question.courseAssessmentCriteria}}</span>
                                    <span style="font-size: 18px" v-else>N/A</span>
                                <br />

                                <span style="font-size: 18px"><strong>Specific Outcome:</strong></span>
                                <br />
                                    <span style="font-size: 18px" v-if="question.courseSpecificOutcome">{{question.courseSpecificOutcome}}</span>
                                    <span style="font-size: 18px" v-else>N/A</span>
                                <br />
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.competentMessage}}</strong></span>
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                <span style="font-size: 18px"><strong>{{question.competent ? "X" :""}}</strong></span>
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px">{{!question.competent ? "X" :""}}</span>
                                </td>

                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>


        <div class="row my-3 mt-5 pt-5 page-break">
            <div class="col-9 m-auto page-break" style="min-width: 900px;">
                <div class="row">
                    <div class="col">
                        <h4><strong>VARCCS Evaluation</strong></h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col w-100 page-break">
                         <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px; width:50%;">
                                    <span style="font-size: 18px"><strong>Evidence in relation to VARCCS</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Yes/No</strong></span>
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Comments</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break" :key="questionIndex"  v-for="(question , questionIndex) in assessorReportData.varccsQuestionDTOs">
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.question}}</strong></span>
                                </td>
                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.answer}}</strong></span>
                                </td>

                                <td class="p-2" style="border-style: solid;border-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{question.comment}}</strong></span>
                                </td>

                            </tr>
                            
                        </table>
                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor Signature</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid; border-right-width: 1px;">
                                    <img style="max-width:100%;max-height:200px;" :src="assessorReportData.assessorSignature" />
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator Signature</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid; border-right-width: 1px;">
                                    <img style="max-width:100%;max-height:200px;" :src="assessorReportData.moderatorSignature" />
                                </td>
                            </tr>
                        </table> 
                    </div>
                </div>
            </div>
        </div>

        <div class="row my-3 mt-5 pt-5">
            <div class="col-9 m-auto" style="min-width: 900px;">
                <div class="row">
                    <div class="col">
                        <h4><strong>Assessor's and Moderator's review of the Assessment</strong></h4>
                    </div>
                </div>
                <div class="row page-break">
                    <div class="col w-100 page-break">
                        <table class="w-100 page-break">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break">
                                <td class="p-2 blue-col" style="border-right-style: solid;border-right-width: 1px; width: 30%">
                                    <span style="font-size: 18px"><strong>Programme</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.programme}}</strong></span>
                                </td>
                            </tr>
                        </table>

                        <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px; width: 30%">
                                    <span style="font-size: 18px"><strong>Unit Standards</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.unitStandards}}</strong></span>
                                </td>
                            </tr>
                        </table>

                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px; width: 30%">
                                    <span style="font-size: 18px"><strong>Assessor name</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.assessorName}}</strong></span>
                                </td>
                            </tr>
                        </table>

                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px; width: 30%">
                                    <span style="font-size: 18px"><strong>Moderator name</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.moderatorName}}</strong></span>
                                </td>
                            </tr>
                        </table>

                        <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px; width: 30%">
                                    <span style="font-size: 18px"><strong>Date</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.assessmentDate}}</strong></span>
                                </td>
                            </tr>
                        </table>

                        <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border grey-background">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Review the Assessment Process</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator</strong></span>
                                </td>
                            </tr>
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border" :key="reviewAnswersIndex" v-for="(reviewAnswers,reviewAnswersIndex) in assessorReportData.assessmentReviewAnswerDTOs.slice(0, 11)">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{reviewAnswersIndex + 1}}</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{reviewAnswers.question}}</strong></span>
                                </td>
                                
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.assessorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-else style="font-size: 18px"><strong>Disagree</strong></span>

                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.moderatorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-if="reviewAnswers.moderatorResponse == false" style="font-size: 18px"><strong>Disagree</strong></span>
                                </td>
                            </tr>
                        </table>

                        <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border grey-background">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Review the Assessment Evidence</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator</strong></span>
                                </td>
                            </tr>

                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border" :key="reviewAnswersIndex" v-for="(reviewAnswers,reviewAnswersIndex) in assessorReportData.assessmentReviewAnswerDTOs.slice(11, 16)">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{12 + reviewAnswersIndex}}</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{reviewAnswers.question}}</strong></span>
                                </td>
                                
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.assessorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-else style="font-size: 18px"><strong>Disagree</strong></span>
                                </td>
                                
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.moderatorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-if="reviewAnswers.moderatorResponse == false" style="font-size: 18px"><strong>Disagree</strong></span>
                                </td>
                            </tr>
                            
                        </table>

                        <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border grey-background">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Review the Assessment Methods</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator</strong></span>
                                </td>
                            </tr>

                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border" :key="reviewAnswersIndex" v-for="(reviewAnswers,reviewAnswersIndex) in assessorReportData.assessmentReviewAnswerDTOs.slice(16, 20)">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{17 + reviewAnswersIndex}}</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{reviewAnswers.question}}</strong></span>
                                </td>
                                
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.assessorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-else style="font-size: 18px"><strong>Disagree</strong></span>
                                </td>
                                

                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.moderatorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-if="reviewAnswers.moderatorResponse == false" style="font-size: 18px"><strong>Disagree</strong></span>
                                </td>
                            </tr>
                            
                        </table>

                        <table class="w-100 page-break" style="">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border grey-background">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong></strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Review: General</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator</strong></span>
                                </td>
                            </tr>

                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border" :key="reviewAnswersIndex" v-for="(reviewAnswers,reviewAnswersIndex) in assessorReportData.assessmentReviewAnswerDTOs.slice(20, 24)">
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{21 + reviewAnswersIndex}}</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{reviewAnswers.question}}</strong></span>
                                </td>
                                
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.assessorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-else style="font-size: 18px"><strong>Disagree</strong></span>
                                </td>

                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span v-if="reviewAnswers.moderatorResponse" style="font-size: 18px"><strong >Agree</strong></span>
                                    <span v-if="reviewAnswers.moderatorResponse == false"  style="font-size: 18px"><strong>Disagree</strong></span>
                                </td>
                            </tr>
                            
                        </table>

                        <table class="w-100 page-break">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2" style="border-right-style: solid; border-right-width: 1px; width: 3%;">
                                    <span style="font-size: 18px"><strong>25</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.assessmentReviewAnswerDTOs[24].question}}</strong></span>
                                    <br />
                                    <span style="font-size: 18px">Assessor Comment: {{assessorReportData.assessmentReviewAnswerDTOs[24].assessorComment}}</span>
                                    <br />
                                    <span style="font-size: 18px">Moderator Comment: {{assessorReportData.assessmentReviewAnswerDTOs[24].moderatorComment}}</span>
                                </td>
                            </tr>

                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border;">
                                <td class="p-2" style="border-right-style: solid; border-right-width: 1px; width: 3%;">
                                    <span style="font-size: 18px"><strong>26</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid;border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>{{assessorReportData.assessmentReviewAnswerDTOs[25].question}}</strong></span>
                                    <br />
                                    <span style="font-size: 18px">Assessor Comment: {{assessorReportData.assessmentReviewAnswerDTOs[25].assessorComment}}</span>
                                    <br />
                                    <span style="font-size: 18px">Moderator Comment: {{assessorReportData.assessmentReviewAnswerDTOs[25].moderatorComment}} </span>
                                </td>
                            </tr>
                        </table>

                        <table class="w-100 page-break" style="table-layout: fixed">
                            <tr style="border-style: solid;border-width: 1px;" class="page-break no-top-border">
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Assessor Signature</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid; border-right-width: 1px;">
                                    <img style="max-width:100%;max-height:200px;" :src="assessorReportData.assessorSignature" />
                                </td>
                                <td class="p-2 blue-col" style="border-right-style: solid; border-right-width: 1px;">
                                    <span style="font-size: 18px"><strong>Moderator Signature</strong></span>
                                </td>
                                <td class="p-2" style="border-right-style: solid; border-right-width: 1px;">
                                    <img style="max-width:100%;max-height:200px;" :src="assessorReportData.moderatorSignature" />
                                </td>
                            </tr>
                        </table> 
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div :class="screenwidth > 850 ? 'w-full overide-zoom' :'vx-row w-full overide-zoom'" style="justify-content: space-between; padding-bottom: 40px;">
        <vs-button color="success" :class="screenwidth > 850 ?  'float-right mr-2 mx-auto' : 'mr-2'" @click="signDocument">Sign</vs-button>
        <vs-button style="margin-right:10px !important" color="danger" :class="screenwidth > 850 ?  'float-right mr-2 mx-auto' : 'mr-2'" @click="appealDocument">Appeal</vs-button>
      </div>
  </div>
</template> 


<script>
import moment from 'moment'
export default {
  data() {
    return { 
      screenwidth: window.innerWidth,
    }
  },
  props:{
    assessorReportData: {
      type: Object,
      required: true
    },
    isStudent:{
      type: Boolean,
      required:false
    },
    isModerator:{
      type: Boolean,
      required:false
    },
  },
  components:{ 
    moment,
  },
  watch:{ 
    screenwidth(){

    }
  },
  computed: { 
    
  },
  methods: { 
    displayDate(date) {
      var self = this;
      if(date) {
        var dateString = new Date(Date.parse(date));
        var result = moment(dateString.toISOString()).format("dddd DD MMMM YYYY");
        return result;
      }
    },
    closeTab(){
      var self = this;
      self.$emit('closeTab');
    },
    onResize() {
      this.screenwidth = window.innerWidth;
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    signDocument(){
      var self = this;
      self.$emit('moderatorQuestions',self.assessorReportData.documentId);
    },
    appealDocument(){
      var self = this;
      self.signDocument();
    },
  },
  mounted(){
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  }
}
</script>


<style lang="scss"> 
.assessorFeedbackSize{
    overflow: hidden;
}
    #Assessor-Report {
        zoom: 0.6;
        font-size: 14px;
        position: relative;
        min-height: 100%;
        margin-bottom: 60px;
        color: black !important;
        font-family: Arial !important;
    }

    .overide-zoom{
        zoom:1.6 !important;
    }
    #Assessor-Report .page-break {
        page-break-inside: avoid !important;
    }

    .blue-col {
        background-color: #99ccff;
        color: black !important;
    }

    .no-top-border {
        border-top: 0px solid !important;
    }

    .no-left-border {
        border-left: 0px solid !important;
    }

    .no-right-border {
        border-left: 0px solid !important;
    }

    .grey-background {
        background-color: #DCDCDC;
    }  

</style>